export default __webpack_public_path__ + "static/media/SIBK_CLUB_PARTNER.7e6dc22b.png";